export function TopBar() {
  return (
    <div className="bg-[--ui-green] text-[#000] py-2 px-4 pb-6 md:py-6 md:px-8 flex flex-col md:flex-row justify-center md:justify-between items-center z-10 text-2xl font-bold text-center md:text-left gap-3 md:gap-4 shrink-0">
      Learn more Tripadvisor AI can benefit your business
      <a
        href="https://airtable.com/appPdRsEK9vHZ5w4i/pagWhgOHFBlh2jc1E/form"
        target="_blank"
        rel="noopener noreferrer"
        className="bg-[#002B10] !text-white px-4 text-lg py-2 rounded-full text-center"
      >
        Get in touch
      </a>
    </div>
  );
}
